module.exports = __webpack_public_path__ + "img/CM-NL-24-Cadillac-Modern.70cbcd82.jpg";